import { Component, Inject, input } from '@angular/core';
import { AppConfig } from '../shared/app.config';
import { DOCUMENT } from '@angular/common';

@Component({
    selector: 'app-left-nav-view',
    templateUrl: './left-nav.component.html',
    styleUrls: ['./left-nav.component.scss'],
    standalone: false
})
export class LeftNavComponent {
  readonly navFeatures = input<string[]>([]);
  region = this.config.region;
  readonly eligActive = input(false);
  readonly userAdminActive = input(false);
  readonly profileActive = input(false);
  renPlan: boolean;
  producerToolkitUrl: string;

  constructor(@Inject(DOCUMENT) private readonly docRef: Document, private readonly config: AppConfig) {
    const pathSegment = this.docRef.location.pathname.split('/')[1].toLowerCase();
    this.renPlan = pathSegment === 'ren';
    this.producerToolkitUrl = `${this.config.producerToolkitUrl}/${pathSegment}`;
  }
}
